module.exports = __webpack_public_path__ + "static/img/notfound.d8c46f2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/template/notfound.svg
// module id = +a35
// module chunks = 3